import { IData } from '../loadInvoiceSettings'
import { IInvoiceSettings } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): IInvoiceSettings => ({
      activeSecondTax: Boolean(Number(item.active_second_tax)),
      activeTax: Boolean(Number(item.active_tax)),
      createdAt: String(item.created_at),
      id: Number(item.id),
      idObject: Number(item.id_object),
      secondTaxName: String(item.default_second_tax_name),
      secondTaxRate: String(item.default_second_tax_rate),
      taxName: String(item.default_tax_name),
      taxRate: String(item.default_tax_rate),
      updatedAt: String(item.updated_at),
      show_dates_on_invoice: Boolean(Number(item.show_dates_on_invoice)),
    }),
  )
}
